const css = `.profile-page {
  --speed: 0.65s;
}
@keyframes zoom {
  from {
    object-position: 0 50%;
  }
  to {
    object-position: 100% 50%;
  }
}
.profile-page p > span {
  margin-left: 8px;
}
.profile-page button {
  align-self: end;
}
.profile-page button[type=submit] {
  margin-left: auto;
}
.profile-page .signature-form .signature-alert {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--danger);
  border-radius: 4px;
  padding: 8px;
  background-color: var(--danger-subtle);
}
.profile-page .signature-form .signature-alert-icon {
  color: var(--danger);
}
.profile-page .signature-form .signature-form-description {
  color: var(--text-muted);
  font-style: italic;
}
.profile-page .signature-form .signature-form-buttons {
  display: flex;
  justify-content: end;
  gap: var(--gap);
  width: 100%;
}
.profile-page .signature-form .signature-form-buttons button {
  margin-left: 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9yZW5kZXIvcHJvamVjdC9zcmMvc3JjL3BhZ2VzL1Byb2ZpbGUiLCJzb3VyY2VzIjpbIlByb2ZpbGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOztBQUVBO0VBQ0U7SUFDRTs7RUFFRjtJQUNFOzs7QUFLRjtFQUNFOztBQUlKO0VBQ0U7O0FBR0Y7RUFDRTs7QUFJQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRTs7QUFHSjtFQUNFO0VBQ0E7O0FBRUY7RUFDRTtFQUNBO0VBQ0E7RUFDQTs7QUFDQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLnByb2ZpbGUtcGFnZSB7XG4gIC0tc3BlZWQ6IDAuNjVzO1xuXG4gIEBrZXlmcmFtZXMgem9vbSB7XG4gICAgZnJvbSB7XG4gICAgICBvYmplY3QtcG9zaXRpb246IDAgNTAlO1xuICAgIH1cbiAgICB0byB7XG4gICAgICBvYmplY3QtcG9zaXRpb246IDEwMCUgNTAlO1xuICAgIH1cbiAgfVxuXG4gIHAge1xuICAgICYgPiBzcGFuIHtcbiAgICAgIG1hcmdpbi1sZWZ0OiA4cHg7XG4gICAgfVxuICB9XG5cbiAgYnV0dG9uIHtcbiAgICBhbGlnbi1zZWxmOiBlbmQ7XG4gIH1cblxuICBidXR0b25bdHlwZT0nc3VibWl0J10ge1xuICAgIG1hcmdpbi1sZWZ0OiBhdXRvO1xuICB9XG5cbiAgLnNpZ25hdHVyZS1mb3JtIHtcbiAgICAuc2lnbmF0dXJlLWFsZXJ0IHtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICBnYXA6IDhweDtcbiAgICAgIGJvcmRlcjogMXB4IHNvbGlkIHZhcigtLWRhbmdlcik7XG4gICAgICBib3JkZXItcmFkaXVzOiA0cHg7XG4gICAgICBwYWRkaW5nOiA4cHg7XG4gICAgICBiYWNrZ3JvdW5kLWNvbG9yOiB2YXIoLS1kYW5nZXItc3VidGxlKTtcblxuICAgICAgJi1pY29uIHtcbiAgICAgICAgY29sb3I6IHZhcigtLWRhbmdlcik7XG4gICAgICB9XG4gICAgfVxuICAgIC5zaWduYXR1cmUtZm9ybS1kZXNjcmlwdGlvbiB7XG4gICAgICBjb2xvcjogdmFyKC0tdGV4dC1tdXRlZCk7XG4gICAgICBmb250LXN0eWxlOiBpdGFsaWM7XG4gICAgfVxuICAgIC5zaWduYXR1cmUtZm9ybS1idXR0b25zIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGVuZDtcbiAgICAgIGdhcDogdmFyKC0tZ2FwKTtcbiAgICAgIHdpZHRoOiAxMDAlO1xuICAgICAgYnV0dG9uIHtcbiAgICAgICAgbWFyZ2luLWxlZnQ6IDA7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iXX0= */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
